import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';

export class AccessDenied extends Component {
    static displayName = AccessDenied.name;

    render() {
        return (
            <div>
                <Container style={{ marginTop: '15%' }}>
                    <Row style={{ padding: '5px' }}>
                        <Col style={{ textAlign: 'center' }}>
                            <h4>Access denied</h4>
                            <div style={{ marginTop: '10px' }}>
                                You do not have permission to access this page.
                                <br />
                                Please contact your Site Administrator(s) to request access.
                            </div>
                        </Col>
                    </Row>

                    <Row style={{ padding: '15px 5px' }}>
                        <Col style={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                            <Button color='primary' onClick={() => this.props.history.push('/')}>
                                Go Home
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}
